import React from 'react';

/**
 * Logo ORIGINAL de PaySlip: lockup "Payslip" + átomo con glow azul.
 * El PNG original (logo-payslip.png) es TRANSPARENTE pero con mucho padding;
 * usamos la versión recortada al contenido (logo-payslip-trim.png, aspecto ~1.92:1).
 * Al ser transparente se coloca directo, sin chip ni blend, y se ve bien en tema
 * claro y oscuro. El wordmark ya viene en la imagen (no se agrega texto aparte).
 */
const LOGO = '/landing/logo-payslip-trim.png';

const Logo2 = ({ size = 36 }) => (
  <img className="ls2-logo" src={LOGO} alt="PaySlip" style={{ height: size, width: 'auto', display: 'block', flexShrink: 0 }} />
);

export default Logo2;
